export default __webpack_public_path__ + "assets/nauru-flag.png";